// import actionType
import {
  GET_MASTER_COMPANY_USAGE_STATS,
  GET_MASTER_COMPANY_USAGE_STATS_SUCCESS,
  GET_MASTER_COMPANY_USAGE_STATS_FAILED,
  GET_MASTER_COMPANY_USAGE_STATS_BY_ID,
  GET_MASTER_COMPANY_USAGE_STATS_BY_ID_SUCCESS,
  GET_MASTER_COMPANY_USAGE_STATS_BY_ID_FAILED,
  GET_COMPANY_LIST,
  GET_COMPANY_LIST_SUCCESS,
  GET_COMPANY_LIST_FAILED,
  GET_COMPANY_BY_ID,
  GET_COMPANY_BY_ID_SUCCESS,
  GET_COMPANY_BY_ID_FAILED,
  GET_COMPANY_RECENT_ACTIVITY_LIST,
  GET_COMPANY_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_COMPANY_RECENT_ACTIVITY_LIST_FAILED,
  MASTER_INVOICE_SEARCH,
  MASTER_INVOICE_SEARCH_SUCCESS,
  MASTER_INVOICE_SEARCH_FAILED,
  MASTER_INVOICE_PDF,
  MASTER_INVOICE_PDF_SUCCESS,
  MASTER_INVOICE_PDF_FAILED,
  MASTER_SYSTEM_ERROR_LOG_LIST,
  MASTER_SYSTEM_ERROR_LOG_LIST_SUCCESS,
  MASTER_SYSTEM_ERROR_LOG_LIST_FAILED,
  MASTER_SYSTEM_ERROR_LOG_DATA,
  MASTER_SYSTEM_ERROR_LOG_DATA_SUCCESS,
  MASTER_SYSTEM_ERROR_LOG_DATA_FAILED,
  MASTER_SYSTEM_ERROR_LOG_SEARCH,
  MASTER_SYSTEM_ERROR_LOG_SEARCH_SUCCESS,
  MASTER_SYSTEM_ERROR_LOG_SEARCH_FAILED,
  GET_MASTER_USER_LIST,
  GET_MASTER_USER_LIST_SUCCESS,
  GET_MASTER_USER_LIST_FAILED,
  GET_MASTER_RECENT_ACTIVITY_LIST,
  GET_MASTER_RECENT_ACTIVITY_LIST_SUCCESS,
  GET_MASTER_RECENT_ACTIVITY_LIST_FAILED,
} from "./actionType";

//initial state
const initialState = {
  masterCompanyUsageStats: [],
  masterCompanyUsageStatsError: "",
  masterCompanyUsageStatsLoading: false,

  masterCompanyUsageStatsById: [],
  masterCompanyUsageStatsByIdError: "",
  masterCompanyUsageStatsByIdLoading: false,

  companyList: [],
  companyListError: "",
  companyListLoading: false,

  companyById: [],
  companyByIdError: "",
  companyByIdLoading: false,

  companyRecentActivityList: [],
  companyRecentActivityListError: "",
  companyRecentActivityListLoading: false,

  masterInvoiceSearch: [],
  masterInvoiceSearchError: "",
  masterInvoiceSearchLoading: false,

  masterInvoicePdf: [],
  masterInvoicePdfError: "",
  masterInvoicePdfLoading: false,

  masterSystemErrorLogList: [],
  masterSystemErrorLogListError: "",
  masterSystemErrorLogListLoading: false,

  masterSystemErrorLogData: [],
  masterSystemErrorLogDataLoading: false,
  masterSystemErrorLogDataError: "",

  masterSystemErrorLogSearch: [],
  masterSystemErrorLogSearchError: "",
  masterSystemErrorLogSearchLoading: false,

  masterUserList: [],
  masterUserListError: "",
  masterUserListLoading: false,

  masterRecentActivityList: [],
  masterRecentActivityListError: "",
  masterRecentActivityListLoading: false,
};

//reducer
const BackendAdmin = (state = initialState, action) => {
  switch (action.type) {
    case GET_MASTER_COMPANY_USAGE_STATS:
      return {
        ...state,
        masterCompanyUsageStatsLoading: true,
      };
    case GET_MASTER_COMPANY_USAGE_STATS_SUCCESS:
      return {
        ...state,
        masterCompanyUsageStatsLoading: false,
        masterCompanyUsageStats: action.data,
      };
    case GET_MASTER_COMPANY_USAGE_STATS_FAILED:
      return {
        ...state,
        masterCompanyUsageStatsLoading: false,
        masterCompanyUsageStatsError: action.error,
      };
    case GET_MASTER_COMPANY_USAGE_STATS_BY_ID:
      return {
        ...state,
        masterCompanyUsageStatsByIdLoading: true,
      };
    case GET_MASTER_COMPANY_USAGE_STATS_BY_ID_SUCCESS:
      return {
        ...state,
        masterCompanyUsageStatsByIdLoading: false,
        masterCompanyUsageStatsById: action.data,
      };
    case GET_MASTER_COMPANY_USAGE_STATS_BY_ID_FAILED:
      return {
        ...state,
        masterCompanyUsageStatsByIdLoading: false,
        masterCompanyUsageStatsByIdError: action.error,
      };
    case GET_COMPANY_LIST:
      return {
        ...state,
        companyListLoading: true,
      };
    case GET_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        companyListLoading: false,
        companyList: action.data,
      };
    case GET_COMPANY_LIST_FAILED:
      return {
        ...state,
        companyListLoading: false,
        companyListError: action.error,
      };
    case GET_COMPANY_BY_ID:
      return {
        ...state,
        companyByIdLoading: true,
      };
    case GET_COMPANY_BY_ID_SUCCESS:
      return {
        ...state,
        companyByIdLoading: false,
        companyById: action.data,
      };
    case GET_COMPANY_BY_ID_FAILED:
      return {
        ...state,
        companyByIdLoading: false,
        companyByIdError: action.error,
      };
    case GET_COMPANY_RECENT_ACTIVITY_LIST:
      return {
        ...state,
        companyRecentActivityListLoading: true,
      };
    case GET_COMPANY_RECENT_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        companyRecentActivityListLoading: false,
        companyRecentActivityList: action.data,
      };
    case GET_COMPANY_RECENT_ACTIVITY_LIST_FAILED:
      return {
        ...state,
        companyRecentActivityListLoading: false,
        companyRecentActivityListError: action.error,
      };
    case MASTER_INVOICE_SEARCH:
      return {
        ...state,
        masterInvoiceSearchLoading: true,
      };
    case MASTER_INVOICE_SEARCH_SUCCESS:
      return {
        ...state,
        masterInvoiceSearchLoading: false,
        masterInvoiceSearch: action.data,
      };
    case MASTER_INVOICE_SEARCH_FAILED:
      return {
        ...state,
        masterInvoiceSearchLoading: false,
        masterInvoiceSearchError: action.error,
      };
    case MASTER_INVOICE_PDF:
      return {
        ...state,
        masterInvoicePdfLoading: true,
      };
    case MASTER_INVOICE_PDF_SUCCESS:
      return {
        ...state,
        masterInvoicePdfLoading: false,
        masterInvoicePdf: action.data,
      };
    case MASTER_INVOICE_PDF_FAILED:
      return {
        ...state,
        masterInvoicePdfLoading: false,
        masterInvoicePdfError: action.error,
      };
    case MASTER_SYSTEM_ERROR_LOG_LIST:
      return {
        ...state,
        masterSystemErrorLogListLoading: true,
      };
    case MASTER_SYSTEM_ERROR_LOG_LIST_SUCCESS:
      return {
        ...state,
        masterSystemErrorLogListLoading: false,
        masterSystemErrorLogList: action.data,
      };
    case MASTER_SYSTEM_ERROR_LOG_LIST_FAILED:
      return {
        ...state,
        masterSystemErrorLogListLoading: false,
        masterSystemErrorLogListError: action.error,
      };
    case MASTER_SYSTEM_ERROR_LOG_DATA:
      return {
        ...state,
        masterSystemErrorLogDataLoading: true,
      };
    case MASTER_SYSTEM_ERROR_LOG_DATA_SUCCESS:
      return {
        ...state,
        masterSystemErrorLogDataLoading: false,
        masterSystemErrorLogData: action.data,
      };
    case MASTER_SYSTEM_ERROR_LOG_DATA_FAILED:
      return {
        ...state,
        masterSystemErrorLogDataLoading: false,
        masterSystemErrorLogDataError: action.error,
      };
    case MASTER_SYSTEM_ERROR_LOG_SEARCH:
      return {
        ...state,
        masterSystemErrorLogSearchLoading: true,
      };
    case MASTER_SYSTEM_ERROR_LOG_SEARCH_SUCCESS:
      return {
        ...state,
        masterSystemErrorLogSearchLoading: false,
        masterSystemErrorLogSearch: action.data,
      };
    case MASTER_SYSTEM_ERROR_LOG_SEARCH_FAILED:
      return {
        ...state,
        masterSystemErrorLogSearchLoading: false,
        masterSystemErrorLogSearchError: action.error,
      };
    case GET_MASTER_USER_LIST:
      return {
        ...state,
        masterUserListLoading: true,
      };
    case GET_MASTER_USER_LIST_SUCCESS:
      return {
        ...state,
        masterUserListLoading: false,
        masterUserList: action.data,
      };
    case GET_MASTER_USER_LIST_FAILED:
      return {
        ...state,
        masterUserListLoading: false,
        masterUserListError: action.error,
      };
    case GET_MASTER_RECENT_ACTIVITY_LIST:
      return {
        ...state,
        masterRecentActivityListLoading: true,
      };
    case GET_MASTER_RECENT_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        masterRecentActivityListLoading: false,
        masterRecentActivityList: action.data,
      };
    case GET_MASTER_RECENT_ACTIVITY_LIST_FAILED:
      return {
        ...state,
        masterRecentActivityListLoading: false,
        masterRecentActivityListError: action.error,
      };

    default:
      return state;
  }
};

export default BackendAdmin;
